import { gql } from "@apollo/client";
import { CORE_MISSION_ROLE_FIELDS, BASIC_MISSION_FIELDS } from "graphql/fragments";

const ADD_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation AddMissionRole($input: AddMissionRoleInput!) {
    addMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const UPDATE_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation UpdateMissionRole($input: UpdateMissionRoleInput!) {
    updateMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const APPLY_MISSION_ROLE_TEMPLATE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation ApplyMissionRoleTemplate($input: ApplyMissionRoleTemplateInput!) {
    applyMissionRoleTemplate(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const REORGANIZE_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  ${BASIC_MISSION_FIELDS}
  mutation ReorganizeMissionRole($input: ReorganizeMissionRoleInput!) {
    reorganizeMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
        mission {
          ...BasicMissionFields
        }
      }
    }
  }
`;

const PUBLISH_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation PublishMissionRole($input: PublishMissionRoleInput!) {
    publishMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const CLOSE_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation CloseMissionRole($input: CloseMissionRoleInput!) {
    closeMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const APPROVE_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation ApproveMissionRole($input: ApproveMissionRoleInput!) {
    approveMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const REOPEN_MISSION_ROLE = gql`
  ${CORE_MISSION_ROLE_FIELDS}
  mutation ReopenMissionRole($input: ReopenMissionRoleInput!) {
    reopenMissionRole(input: $input) {
      missionRole {
        ...MissionRoleFields
      }
    }
  }
`;

const UPDATE_MISSION_ROLE_REQUIREMENTS = gql`
  mutation UpdateMissionRoleRequirements($input: UpdateMissionRoleRequirementsInput!) {
    updateMissionRoleRequirements(input: $input) {
      missionRole {
        id
        requirements {
          id
          description
        }
        requirementsLocked
      }
    }
  }
`;

export {
  ADD_MISSION_ROLE,
  UPDATE_MISSION_ROLE,
  APPLY_MISSION_ROLE_TEMPLATE,
  REORGANIZE_MISSION_ROLE,
  PUBLISH_MISSION_ROLE,
  CLOSE_MISSION_ROLE,
  REOPEN_MISSION_ROLE,
  APPROVE_MISSION_ROLE,
  UPDATE_MISSION_ROLE_REQUIREMENTS,
};
